import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function RiderTraining() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Title Section */}
      <div className="mt-16 md:mt-24 py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-6 md:mb-8 font-light">
            RIDER TRAINING
          </h1>

          <p className="text-center text-gray-800 mb-4">
            Visit our <Link to="/park-rules" className="text-red-600 underline font-semibold">Park Info/Rules</Link> page to read over all rules and regulations prior to lessons and rentals.
          </p>

          <p className="text-center font-bold text-lg mb-8" style={{ color: '#F5A623' }}>
            For Bookings: <a href="mailto:bookings@throttledge.com" className="text-red-600 hover:underline">bookings@throttledge.com</a>
          </p>

          <div className="flex justify-center mb-16">
            <Link 
              to="/gift-certificates"
              className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-sm font-bold tracking-widest inline-block"
            >
              GIFT CERTIFICATES
            </Link>
          </div>

          {/* Training Programs */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
            {/* Red Rider Training */}
            <div>
              <img 
                src="/a14.png" 
                alt="Red Rider Training" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Red Rider Training
              </h2>
              <div className="space-y-4 text-gray-800 leading-relaxed">
                <p>
                  Throttle Edge offers rider training to those who have never experienced off-roading before. We provide the proper safety equipment, a full range of Honda off-road motorcycles (50cc to 250cc), and 2-hour instruction.
                </p>
                <p>
                  Each session starts off in our grass training area where riders will learn to operate the machines while negotiating their way around cones. From this point riders will move to our Red Rider beginner course to get a feel for track & trail riding.
                </p>
                <p>
                  Once the students have mastered each of the lessons with the instructor, they will then be taken on a guided track & trail ride for the remainder of the session.
                </p>
                <p className="font-semibold">Price: PKR 43,470 + HST per student (2 hour lesson)</p>
                <p className="font-semibold">Includes: Bike, Safety gear, Instruction</p>
                <p className="text-sm">* Age 4 and up</p>
              </div>
            </div>

            {/* Off-Road Rider Training */}
            <div>
              <img 
                src="/a5.jpeg" 
                alt="Off-Road Rider Training" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Off-Road Rider Training
              </h2>
              <div className="space-y-4 text-gray-800 leading-relaxed">
                <p>
                  Throttle Edge offers a 2 hour Off-Road training session for Novice riders who have their own bike and want to improve on their riding skills - tracks or trails.
                </p>
                <p className="font-semibold">Price: PKR 22,770 + HST per student (2 hour lesson)</p>
                <p className="font-semibold">Includes: Instruction</p>
                <p className="text-sm">* Age 6 and up</p>
              </div>
            </div>

            {/* Advanced Motocross Coaching */}
            <div>
              <img 
                src="/a7.jpeg" 
                alt="Advanced Motocross Coaching" 
                className="w-full h-64 object-cover mb-6"
              />
              <h2 className="text-3xl font-bold mb-4 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Advanced Motocross Coaching
              </h2>
              <div className="space-y-4 text-gray-800 leading-relaxed">
                <p>
                  Our Advanced Motocross Coaching is a 2 hour training session for advanced riders and/or racers looking to improve the technical aspect of their riding and racing skills.
                </p>
                <p>
                  This is for advanced level riders only, for novice riders see off-road training section. See details for pricing.
                </p>
                <p className="font-semibold">Price: PKR 40,365 + HST per student (2 hour session)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default RiderTraining;
